// src/components/ConversationHeader.js
import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Box, 
  Chip, 
  Avatar,
  useTheme
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TargetIcon from "@mui/icons-material/Flag";

// Language mapping with native names and flag codes
const languageData = {
  'en': { native: 'English', flag: 'gb' },
  'es': { native: 'Español', flag: 'es' },
  'fr': { native: 'Français', flag: 'fr' },
  'de': { native: 'Deutsch', flag: 'de' },
  'it': { native: 'Italiano', flag: 'it' },
  'pt': { native: 'Português', flag: 'pt' },
  'ja': { native: '日本語', flag: 'jp' },
  'ko': { native: '한국어', flag: 'kr' },
  'zh': { native: '中文', flag: 'cn' },
  'ru': { native: 'Русский', flag: 'ru' },
  'ar': { native: 'العربية', flag: 'sa' },
  'hi': { native: 'हिन्दी', flag: 'in' },
  // Add more languages as needed
};

const ConversationHeader = ({ title, goal, language, onBack }) => {
  const theme = useTheme();
  
  // Get language data or provide fallback
  const langData = languageData[language] || { 
    native: language.toUpperCase(), 
    flag: 'un' // United Nations flag as fallback
  };
  
  // Flag URL (using free country flags API)
  const flagUrl = `https://flagcdn.com/w40/${langData.flag}.png`;
  
  return (
    <AppBar 
      position="static" 
      elevation={2}
      sx={{ 
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1, 
        borderColor: 'divider',
      }}
    >
      <Toolbar sx={{ py: 1.5 }}>
        <IconButton 
          edge="start" 
          color="primary" 
          onClick={onBack} 
          aria-label="back"
          sx={{ mr: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          flexGrow: 1
        }}>
          <Typography 
            variant="h6" 
            component="div" 
            fontWeight="bold"
            color="primary"
          >
            {title}
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
            <TargetIcon 
              fontSize="small" 
              sx={{ 
                mr: 0.5, 
                color: theme.palette.text.secondary,
                opacity: 0.8
              }} 
            />
            <Typography 
              variant="body2" 
              sx={{ 
                color: theme.palette.text.secondary,
                fontWeight: 500
              }}
            >
              {goal}
            </Typography>
          </Box>
        </Box>
        
        <Chip
          avatar={<Avatar src={flagUrl} alt={langData.native} />}
          label={langData.native}
          color="primary"
          variant="outlined"
          sx={{ 
            fontWeight: 600,
            fontSize: '0.875rem',
            height: 36,
            border: `2px solid ${theme.palette.primary.main}`,
            '& .MuiChip-avatar': {
              width: 24,
              height: 24
            }
          }}
        />
      </Toolbar>
    </AppBar>
  );
};

export default ConversationHeader;